// Scripts
import Swiper from 'swiper'
import { extend } from '../libs/utils'
import { Autoplay, Pagination, EffectFade } from 'swiper/modules'

// Styles
import 'swiper/css/bundle'

// configure Swiper to use modules
Swiper.use([Autoplay, Pagination, EffectFade])

// gestion des carrousels
const els = document.querySelectorAll('.hero-carousel')
for (const swiper of els) {
  const container = swiper.querySelector('.swiper')
  if (!container.classList.contains('swiper-initialized')) {
    const options = swiper.hasAttribute('data-plugin-options')
      ? swiper.getAttribute('data-plugin-options').replace(/'/g, '"')
      : {}
    // default carousel configuration
    const defaults = {
      pagination: {
        el: swiper.getElementsByClassName('swiper-pagination')[0],
        dynamicBullets: true,
        clickable: true
      },
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 0,
      effect: 'fade',
      loop: true,
      preloadImages: false, // Disable preloading of all images
      lazy: {
        // Enable lazy loading
        loadOnTransitionStart: true
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      on: {
        lazyImageReady (swiper, slide, img) {
          // https://github.com/nolimits4web/swiper/issues/5667
          if (img.complete) {
            swiper.update()
          } else {
            img.addEventListener('load', () => {
              swiper.update()
            })
          }
        }
      }
    }
    const obj = options.length > 0 ? JSON.parse(options) : {}
    const config = extend(true, defaults, obj)
    const slider = new Swiper(container, config)
    slider.init()
  }
}
